export const normalizeText = (text) => {
  return (text || '')
    .toLowerCase()
    .replace(/x|-/g, '')
    .replace(/\s+/g, '');
};

export const sortResults = (results) => {
  if (!Array.isArray(results) || results.length === 0) {
    return [];
  }
  return [...results].sort((a, b) => {
    const aSize = a['Bolt Size'] || '';
    const bSize = b['Bolt Size'] || '';
    return aSize.localeCompare(bSize);
  });
}; 